<template lang="pug">
div
  .dropbox
    input.input-file(
      type="file",
      multiple,
      :name="uploadFieldName",
      :disabled="isSaving",
      @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length",
      accept="*/*"
    )
    p.body-1(v-if="isInitial") Drag your file here to begin<br> or click to browse
    p.body-1(v-if="isSaving") Uploading {{ fileCount }} files...
    p.body-1(v-if="isSuccess") Uploaded {{ data.uploadedFiles.length }} file(s) successfully.
    p.pb-0.red--text.text--lighten-1.pl-4(v-if="isFailed") Upload failed, please try again. <br> {{ uploadError.parsedBody.message }}
  div.pt-4(v-if="data.uploadedFiles.length > 0")
    p.pb-0.body-1(v-if="data.uploadedFiles.length > 0") Attachments
    ul(v-if="data.uploadedFiles.length > 0")
      li(v-for="item in data.uploadedFiles") {{ item }}
</template>
<script>
import { mapState } from "vuex";
import { mapMultiRowFields } from "vuex-map-fields";
import store from "../store";
import service from "../data/service";

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  props: {
    docId: String,
  },
  components: {
    //
  },
  store,
  computed: {
    ...mapState({
      data: (state) => state.data,
    }),
    ...mapMultiRowFields(["data.uploadedFiles"]),
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
  },
  data: () => ({
    uploadError: null,
    currentStatus: null,
    uploadFieldName: "sitePlan",
  }),
  methods: {
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadError = null;
    },
    filesChange(fieldName, fileList) {
      if (!fileList.length) return;
      this.currentStatus = STATUS_SAVING;
      Array.from(Array(fileList.length).keys()).map((x) => {
        service
          .upload(fileList[x], fileList[x].name, this.$props.docId)
          .then((returnResponse) => {
            console.log({ returnResponse: returnResponse });
            this.data.uploadedFiles.push(returnResponse.fileName);
            this.currentStatus = STATUS_SUCCESS;
          })
          .catch((err) => {
            this.uploadError = err.response;
            console.log(this.uploadError);
            this.currentStatus = STATUS_FAILED;
          });
      });
    },
  },
  mounted() {
    this.reset();
  },
};
</script>
<style lang="scss">
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  background: #f1f1f1;
  outline-offset: -10px;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background:  #82b1ff; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>